<template>
  <div>
    <div
      class="modal fade"
      id="dividirPickingModal"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Dividir Picking</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="col-12">
            <UsuariosSelectComponent :current="currentDetalle" />
            <button
              @click="generarDivisionPicking()"
              class="btn btn-success btn-block"
            >
              Generar división de picking
            </button>
            <hr />
          </div>
          <div style="height: 300px; overflow: auto" class="modal-body">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Subcategoria</th>
                  <th>SKUS</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(d, index) in categoriasPicking"
                  :value="d"
                  :key="index"
                >
                  <td>
                    {{ d.producto__sub_categoria_id }} -
                    {{ d.producto__sub_categoria__nombre }}
                  </td>
                  <td>{{ d.total_skus }}</td>
                  <td>
                    <input
                      type="checkbox"
                      class="form-control"
                      @change="AgregarArrayCategoria(d)"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="text-center">ultima linea</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="cambiarUsuarioPicking"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Cambiar de usuario el picking</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
              <UsuariosSelectComponent :current="currentDetalle" />
            </div>
          </div>
          <div class="modal-footer">
            <button
              @click="cambiarUsurioPicking()"
              class="btn btn-success btn-block"
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";

export default {
  components: {
    UsuariosSelectComponent,
  },
  props: {
    categoriasPicking: {
      type: Array,
    },
    despachoe: {
      type: Object,
    },
  },
  data() {
    return {
      select: false,
      currentDetalle: {
        categoria: "",
        categorias_: [],
        categorias: [],
        usuario_asignar: "",
        usuario: "",
      },
      categorias: [],
      errors: [],
      error: [],
    };
  },
  mounted() {},
  methods: {
    cambiarUsurioPicking() {
      if (!this.currentDetalle.usuario) {
        Notifications.alert.error(
          "Cambiar usuario de picking",
          "El campo usuario no puede estar en blanco"
        );
        return;
      }
      DynamicService.postAction(
        "wms",
        "picking-despacho",
        this.despachoe.id,
        "cambiar_usuario_picking",
        {
          usuario_asignar: this.currentDetalle.usuario.id,
        }
      )
        .then((response) => {
          this.$router.push({ path: `/wms/despachos/${response.data.id}/` });
          this.$emit("refreshCurrent");
          Notifications.alert.success(
            "Cambiar usuario de picking",
            "Realizado Exitosamente"
          );
          this.retetDataDividirPick();
          $("#cambiarUsuarioPicking").modal("hide");
        })
        .catch((errors) => {
          this.retetDataDividirPick();
          Notifications.alert.error(
            "Cambiar usuario de picking",
            errors.response.data.detail
          );
        });
    },
    generarDivisionPicking() {
      if (!this.currentDetalle.usuario) {
        Notifications.alert.error(
          "Dividir picking Depacho",
          "El campo usuario no puede estar en blanco"
        );
        return;
      }
      DynamicService.postAction(
        "wms",
        "picking-despacho",
        this.despachoe.id,
        "dividir_picking",
        {
          sub_categorias: this.currentDetalle.categorias_,
          usuario_asignar: this.currentDetalle.usuario.id,
        }
      )
        .then((response) => {
          this.$router.push({ path: `/wms/despachos/${response.data.id}/` });
          this.$emit("refreshCurrent");
          Notifications.alert.success(
            "Dividir Picking Despacho",
            "Realizado Exitosamente"
          );
          this.retetDataDividirPick();
          $("#dividirPickingModal").modal("hide");
        })
        .catch((errors) => {
          this.retetDataDividirPick();
          Notifications.alert.error(
            "Dividir Picking Despacho",
            errors.response.data.detail
          );
        });
    },
    retetDataDividirPick() {
      this.currentDetalle.categorias_ = [];
      this.select = false;
      this.currentDetalle.usuario = "";
    },
    refreshCategoriasArray() {
      this.currentDetalle.categorias_ = [];
    },
    AgregarArrayCategoria(d) {
      if (!d) {
        return;
      }
      if (
        this.currentDetalle.categorias_.includes(d.producto__sub_categoria_id)
      ) {
        this.currentDetalle.categorias_ =
          this.currentDetalle.categorias_.filter(function (det) {
            return det !== d.producto__sub_categoria_id;
          });
        return;
      }
      this.currentDetalle.categorias_.push(d.producto__sub_categoria_id);
      this.currentDetalle.categoria = "";
    },
  },
};
</script>
